<template>
  <div class="checklist__header mb-1">
    <span class="ml-2 checklist__header__item">OK</span>
    <span class="ml-4 checklist__header__item">NC</span>
    <span class="ml-4 checklist__header__item">NA</span>
    <span class="ml-4 checklist__header__item">{{ title }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .checklist__header {
    background: #ccc;

    &__item {
      font-weight: bold;
    }
  }
</style>
